import { Link } from "react-router-dom";
import Logo from "../images/washingMachine.png";
import PageContainer from "./layouts/PageContainer";

export default function NotFound() {
  return (
    <PageContainer className="sq-not-found">
      <img src={Logo} alt="" />
      <h1>You've ended up in the land of missing socks!</h1>
      <p>We couldn't find that page.</p>
      <Link to="/home" className="btn btn-primary">
        Back to home
      </Link>
    </PageContainer>
  );
}
